/* eslint-disable camelcase */

import moduleTemplate from '@/store/moduleTemplate'
import companiesAPI from '@/api/companies'

export default moduleTemplate(companiesAPI)
